export default ({ color }) => ({
  progressBar: {
    background: color.background,
    width: '94%',
    height: 12,
    border: `1px solid ${color.bodyText}`,
    marginLeft: 24,
    display: 'inline-flex',
  },
  progressBarProgress: {
    background: `${color.bodyText} 0% 0% no-repeat padding-box`,
    height: 11,
    maxWidth: '100%',
  },
  progressBarErrorProgress: {
    background: 'red 0% 0% no-repeat padding-box',
    height: 11,
    maxWidth: '100%',
  },
  '@media only screen and (max-width: 1400px)': {
    progressBar: {
      width: '90%',
    },
  },
  '@media only screen and (max-width: 1170px)': {
    progressBar: {
      width: '80%',
    },
  },
});